export const benefitIds = [
  'SellingInfoPage.benefit.modelMatch',
  'SellingInfoPage.benefit.compare',
  'SellingInfoPage.benefit.fixedPrices',
  'SellingInfoPage.benefit.fastListing',
  'SellingInfoPage.benefit.racketportHandles',
];

export const saleSteps = [
  {
    title: 'SellingInfoPage.step.searchModel.title',
    text: 'SellingInfoPage.step.searchModel.text',
  },
  {
    title: 'SellingInfoPage.step.createListing.title',
    text: 'SellingInfoPage.step.createListing.text',
  },
  {
    title: 'SellingInfoPage.step.stripe.title',
    text: 'SellingInfoPage.step.stripe.text',
  },
  {
    title: 'SellingInfoPage.step.ship.title',
    text: 'SellingInfoPage.step.ship.text',
  },
  {
    title: 'SellingInfoPage.step.tracking.title',
    text: 'SellingInfoPage.step.tracking.text',
  },
  {
    title: 'SellingInfoPage.step.payout.title',
    text: 'SellingInfoPage.step.payout.text',
  },
];

export const paymentFlowItems = [
  {
    title: 'SellingInfoPage.paymentFlow.buyer.title',
    text: 'SellingInfoPage.paymentFlow.buyer.text',
  },
  {
    title: 'SellingInfoPage.paymentFlow.stripe.title',
    text: 'SellingInfoPage.paymentFlow.stripe.text',
  },
  {
    title: 'SellingInfoPage.paymentFlow.tracking.title',
    text: 'SellingInfoPage.paymentFlow.tracking.text',
  },
  {
    title: 'SellingInfoPage.paymentFlow.payout.title',
    text: 'SellingInfoPage.paymentFlow.payout.text',
  },
];

export const heroOfferSteps = [
  'SellingInfoPage.heroPanel.modelValue',
  'SellingInfoPage.heroPanel.conditionValue',
  'SellingInfoPage.heroPanel.priceValue',
  'SellingInfoPage.heroPanel.photosValue',
];

export const reputationPointIds = [
  'SellingInfoPage.reputation.point.photos',
  'SellingInfoPage.reputation.point.condition',
  'SellingInfoPage.reputation.point.shipping',
];

export const faqItems = [
  {
    question: 'SellingInfoPage.faq.whatToSell.question',
    answer: 'SellingInfoPage.faq.whatToSell.answer',
  },
  {
    question: 'SellingInfoPage.faq.business.question',
    answer: 'SellingInfoPage.faq.business.answer',
  },
  {
    question: 'SellingInfoPage.faq.listingCost.question',
    answer: 'SellingInfoPage.faq.listingCost.answer',
  },
  {
    question: 'SellingInfoPage.faq.sellingFee.question',
    answer: 'SellingInfoPage.faq.sellingFee.answer',
  },
  {
    question: 'SellingInfoPage.faq.negotiation.question',
    answer: 'SellingInfoPage.faq.negotiation.answer',
  },
  {
    question: 'SellingInfoPage.faq.offPlatform.question',
    answer: 'SellingInfoPage.faq.offPlatform.answer',
  },
  {
    question: 'SellingInfoPage.faq.description.question',
    answer: 'SellingInfoPage.faq.description.answer',
  },
  {
    question: 'SellingInfoPage.faq.photos.question',
    answer: 'SellingInfoPage.faq.photos.answer',
  },
  {
    question: 'SellingInfoPage.faq.payoutTime.question',
    answer: 'SellingInfoPage.faq.payoutTime.answer',
  },
  {
    question: 'SellingInfoPage.faq.stripe.question',
    answer: 'SellingInfoPage.faq.stripe.answer',
  },
  {
    question: 'SellingInfoPage.faq.noConfirmation.question',
    answer: 'SellingInfoPage.faq.noConfirmation.answer',
  },
];
